import React from 'react';
import PropTypes from 'prop-types';

export default class CustomPageDetailContentManufacrurerLargeLayoutItem extends React.Component {

  static propTypes = {
    pageBlockItem: PropTypes.any.isRequired
  };

  render() {
    let pageBlockItem = this.props.pageBlockItem;

    return (
      <li className="col px-0">
        <figure className="img">
          <a href={pageBlockItem.itemUrl}>
            <span><img className="m_imgShadow" src={pageBlockItem.itemImageUrl} alt=""/></span>
          </a>
        </figure>
        <div className="dtl">
          <p className="ttl"><span><a target="_blank" href={pageBlockItem.itemUrl}>{pageBlockItem.itemName}</a></span></p>
          <p className="subTxt"><a href={pageBlockItem.extendProperties.itemCompanyUrl}>{pageBlockItem.extendProperties.itemCompanyName}</a></p>
          <p className="label">{pageBlockItem.itemCategoryName}</p>
          {pageBlockItem.itemDescription && <p className="subTxt" style={{whiteSpace: 'pre-wrap'}}>{pageBlockItem.itemDescription}</p>}
        </div>
      </li>
    );
  }
}
